import { getCurrentDate } from "../../cpcoc/currentDate";
import { getReadingPlan } from "./readingPlan";
export function getDateState(date) {
    let state = "";
    const currentDate = getCurrentDate();
    const readingPlan = getReadingPlan();
    const startDate = new Date(readingPlan.startDate);
    const endDate = readingPlan.endDate && new Date(readingPlan.endDate);
    if (date.toLocaleDateString() === currentDate.toLocaleDateString()) {
        state = "active";
    }
    else if (date < currentDate && startDate <= date) {
        state = "past";
    }
    if (startDate < date && (!endDate || date < endDate)) {
        state += " plan";
    }
    return state;
}
